/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './krishak.css';
import Select from 'react-select';
import Utilities from '../../global/Utilities';
import moment from 'moment';
import { ADD_KRISHAK_SCREEN, COMMON, HOME_TODAY_SCREEN, SYNC_SERVICE } from '../../global/Constants';
import SyncServices from '../../providers/SyncServices';


class General extends Component {

    constructor(props) {
        super(props)

        this.state = {
            currentTab: 0,
            type: 'text',
            isPrerakChecked: false,
            isAppsVisible: null,
            isPrerakVisible: false,
            canBePrerak: null,
            selectedIrrigation: null,
            selectedEducation: null,
            selectedState: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            selectedPrerak: null,
            selectedApps: [],
            allStatesData: [],
            allDistrictsData: [],
            allTehsilsData: [],
            allVillagesData: [],
            allAppsData: [],
            allPrerakData: [],
            allQualificationData: [],
            allIrrigationData: [],
            fields: {
                name: "",
                mobile: "",
                dob: ""
            },
        }
    }

    componentDidMount() {
        this.getAllStates();
        this.getAllApps();
        this.getAllQualification();
        this.getAllIrrigationSource();
        this.props._handleNextButton(false);
        let krishakData = this.props.krishakData;
        let mobileNumber = this.props.mobileNumber;

        if (krishakData) {

            Utilities.LogPrint("componentDidMountGeneral", krishakData);
            this.setState({
                fields: {
                    name: krishakData.name,
                    dob: moment(krishakData.dob, "YYYY-MM-DD").format("DD-MM-YYYY"),
                    mobile: mobileNumber
                },
                selectedState: {
                    value: krishakData.state_id,
                    label: krishakData.state_name
                },
                selectedDistrict: {
                    value: krishakData.district_id,
                    label: krishakData.district_name
                },
                selectedTehsil: {
                    value: krishakData.tehsil_id,
                    label: krishakData.tehsil_name
                },
                selectedVillage: {
                    value: krishakData.village_id,
                    label: krishakData.village_name
                },
                selectedPrerak: (krishakData.prerak_name_phone) ? {
                    value: krishakData.prerak_name_phone.krishak_id,
                    label: krishakData.prerak_name_phone.name + "(" + krishakData.prerak_name_phone.phone + ")"
                } : null,
                isPrerakVisible: krishakData.is_know_prerak === 1,
                canBePrerak: krishakData.is_prerak ? krishakData.is_prerak === 1 : false,
                isAppsVisible: krishakData.is_smart_phone === 1,
                selectedEducation: krishakData.qualification_id,
                selectedApps: krishakData.phone_app?.map(({ phone_app_id: value, name: label, ...rest }) => ({ value, label, ...rest })),
                selectedIrrigation: krishakData.irrigation_source_name

            }, () => {
                this.getAllPrerak(this.state.selectedState.value);
                this.updateNextButton();
            })
        } else if (mobileNumber) {
            this.setState({
                fields: {
                    name: this.state.fields["name"],
                    dob: this.state.fields["dob"],
                    mobile: mobileNumber
                }
            });
        }
        else {
            Utilities.LogPrint("componentDidMountGeneral", "No data Found");
        }

    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields });
        this.updateNextButton();
    };

    updateNextButton = () => {
        const { allQualificationData, selectedApps, selectedTehsil, selectedVillage, selectedPrerak, selectedDistrict, selectedState, isAppsVisible, canBePrerak, isPrerakVisible, selectedIrrigation, selectedEducation } = this.state;
        // let dob = document.getElementById("dob").value;

        let dob = moment(this._getFieldValue("dob", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        if (dob === 'Invalid date') {
            dob = "";
        }
        Utilities.LogPrint("DOB", dob);

        const name = this._getFieldValue("name", "");
        const mobile = this._getFieldValue("mobile", "");

        let isEnable = (
            name !== "" && mobile !== "" && mobile.length === 10
            && selectedTehsil !== null && selectedVillage !== null
            && (isPrerakVisible != null ? (isPrerakVisible ? (selectedPrerak) : true) : false)
            && canBePrerak !== null);

        // let isEnable = (dob !== "" && 
        //     name !== "" && mobile !== "" && mobile.length === 10
        //     && selectedTehsil !== null && selectedVillage !== null && selectedIrrigation !== null
        //     && (isAppsVisible != null ? (isAppsVisible ? (selectedApps.length !== 0) : true) : false)
        //     && selectedEducation !== null
        //     && (isPrerakVisible != null ? (isPrerakVisible ? (selectedPrerak) : true) : false)
        //     && canBePrerak !== null);

        let newSelectedApps = []

        for (var i = 0; i < selectedApps.length; i++) {
            newSelectedApps.push(selectedApps[i].value)
        }
        let selectedEducationName = allQualificationData.find(item => item.value === parseInt(selectedEducation));

        Utilities.LogPrint("componentDidMountGeneral123", (selectedEducationName === undefined) ? "" : selectedEducationName.label);

        if (isEnable) {

            var personalDetails = {
                name: name,
                mobile: mobile,
                dob: dob,
            };
            var locationDetails = {
                selectedVillage: selectedVillage,
                selectedTehsil: selectedTehsil,
                selectedDistrict: selectedDistrict,
                selectedState: selectedState,
            };
            var additionalDetails = {
                education: parseInt(selectedEducation),
                educationName: selectedEducationName,
                isSmartPhoneUser: isAppsVisible ? 1 : 0,
                appsUsed: newSelectedApps,
                selectedApps,
                isPrerak: isPrerakVisible ? 1 : 0,
                canPrerak: canBePrerak ? 1 : 0,
                prerakMobileNumber: selectedPrerak
            };
            const newArray = this.state.allIrrigationData.slice(); // Create a copy
            var irrigationSource;
            if (newArray.some(e => e.name === selectedIrrigation)) {
                /* selectedIrrigation not contains the element we're looking for */
                var index = newArray.indexOf(newArray.find((element) => {
                    return element.name === selectedIrrigation;
                }));
                if (index !== -1) {
                    irrigationSource = {
                        irrigation: newArray[index],
                    };
                }
            }
            var general = {
                personalDetails: personalDetails,
                locationDetails: locationDetails,
                additionalDetails: additionalDetails,
                irrigationSource: irrigationSource,
            };
        }
        Utilities.LogPrint("generalUpdateNext", general);
        this.props._handleNextButton(isEnable, general, "general");
    }

    getAllIrrigationSource = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_IRRIGATION_SOURCE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allIrrigationData: data
                }, () => {
                    this.updateNextButton();
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "DESC"
        // });
        // try {
        //     ApiServices.getAllIrrigationSource(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const newArrayOfObj = response.data.data;
        //             this.setState({ allIrrigationData: newArrayOfObj })
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("allIrrigationData", this.state.allIrrigationData);
        //         } else {
        //             Utilities.LogPrint("allIrrigationData", response);
        //             this.props.loaderCallback(false);
        //         }
        //         this.updateNextButton();
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("allIrrigationData", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("allIrrigationData", error);
        // }
    }

    getAllQualification = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_QUALIFICATION, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allQualificationData: data.map(({ qualification_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 100,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "ASC"
        // });
        // try {
        //     ApiServices.getAllQualification(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const newArrayOfObj = response.data.data.map(({ qualification_id: value, name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ allQualificationData: newArrayOfObj });
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getAllQualification", this.state.allQualificationData);
        //         } else {
        //             Utilities.LogPrint("getAllQualification", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getAllQualification", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getAllQualification", error);
        // }
    }

    getAllApps = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_PHONE_APP, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allAppsData: data.map(({ phone_app_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "DESC"
        // });
        // try {
        //     ApiServices.getAllApps(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const newArrayOfObj = response.data.data.map(({ phone_app_id: value, name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ allAppsData: newArrayOfObj });
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getAllApps", this.state.allAppsData);
        //         } else {
        //             Utilities.LogPrint("getAllApps", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getAllApps", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getAllApps", error);
        // }
    }

    getAllStates = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_STATE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 1000,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "ASC",
        //     lastSync: "2021-01-01 00:00:00"
        // });
        // try {
        //     ApiServices.getAllStates(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const newArrayOfObj = response.data.data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ allStatesData: newArrayOfObj });
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getAllStates", this.state.allStatesData);
        //         } else {
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getAllStates", response);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getAllStates", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getAllStates", error);
        // }
    }

    getAllPrerak = (id) => {

        SyncServices.getKrishakFromDatabase("is_prerak", "true").then(data => {
            if (data && data !== undefined && data.length > 0) {
                let preraks = [];
                for (var i = 0; i < data.length; i++) {
                    let data1 = data[i].data;
                    preraks.push({
                        value: data1.krishak_id,
                        label: data1.name + "(" + data1.phone + ")"
                    });
                }
                this.setState({
                    allPrerakData: preraks,
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     get_by: "state_id",
        //     get_by_value: id,
        // });
        // try {
        //     ApiServices.getAllPrerak(body).then(response => {
        //         var status = response.success;
        //         this.props.loaderCallback(false);
        //         if (status) {
        //             let preraks=[];
        //             for (var i = 0; i < response.data.length; i++){
        //                 let data = response.data[i];
        //                 preraks.push({
        //                     value:data.krishak_id,
        //                     label:data.name+"("+data.phone+")"
        //                 });
        //             }
        //             this.setState({ allPrerakData: preraks });
        //             Utilities.LogPrint("getAllPrerak", this.state.allPrerakData);
        //         } else {
        //             Utilities.LogPrint("getAllPrerak", response);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getAllPrerak", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getAllPrerak", error);
        // }
    }

    getAllDistricts = (selectedState) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_DISTRICT, SYNC_SERVICE.MASTER_TABLE).then(data => {

            if (data && data !== undefined && data.length > 0) {

                var filterData = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].state_id === selectedState.value) {
                        filterData.push(data[i]);
                    }
                }
                this.setState({
                    allDistrictsData: filterData.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllTehsils = (selectedDistrict) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                var filterData = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].district_id === selectedDistrict.value) {
                        filterData.push(data[i]);
                    }
                }
                this.setState({
                    allTehsilsData: filterData.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllVillageById = (selectedTehsil) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                var filterData = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].tehsil_id === selectedTehsil.value) {
                        filterData.push(data[i]);
                    }
                }
                this.setState({
                    allVillagesData: filterData.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // this.props.loaderCallback(true);
        // const { selectedState, selectedDistrict } = this.state;
        // var body = JSON.stringify({
        //     tehsil_id: selectedTehsil.value,
        //     state_id: selectedState.value,
        //     district_id: selectedDistrict.value,
        //     page: 1,
        //     perPage: 1000,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "ASC",
        //     lastSync: "2021-01-01 00:00:00"
        // });

        // try {
        //     ApiServices.getAllVillageById(body)
        //         .then(response => {
        //             var status = response.success
        //             this.props.loaderCallback(false)
        //             if (status) {
        //                 const newArrayOfObj = response.data.slice(0, 10).map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }));
        //                 this.setState({ allVillagesData: newArrayOfObj })
        //                 Utilities.LogPrint("_getAllVillageApi", this.state.allVillagesData);
        //             }
        //             else {
        //                 Utilities.LogPrint("_getAllVillageApi", response.message);
        //             }
        //         })
        //         .catch(error => {
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("_getAllVillageApi", error);
        //         });
        // }
        // catch (error) {
        //     // this.setState({ isLoading: false });
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("_getAllVillageApi", error);
        // }

    }

    getInitialState = () => {
        return {
            type: 'text'
        };
    }

    handleOnMenuClose = () => {
        this.updateNextButton()
    }

    handleStateChange = selectedState => {
        if (selectedState === null) {
            this.setState({
                selectedState: null,
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
                selectedPrerak: null,
                allPrerakData: []
            });
        } else {
            this.setState({
                selectedState, selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null, allDistrictsData: [], allPrerakData: [], allTehsilsData: [], allVillagesData: []
            }, () => {
                this.getAllDistricts(selectedState);
                this.getAllPrerak(selectedState.value);
            });
        }
        this.updateNextButton()
    };

    handleDistrictChange = selectedDistrict => {
        if (selectedDistrict === null) {
            this.setState({
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedDistrict, selectedTehsil: null,
                selectedVillage: null, allTehsilsData: [], allVillagesData: []
            });
            this.getAllTehsils(selectedDistrict);
        }
        this.updateNextButton()
    };

    handleTehsilChange = selectedTehsil => {
        if (selectedTehsil === null) {
            this.setState({
                selectedTehsil: null,
                selectedVillage: null,
            }, () => {
                this.updateNextButton();
            });
        } else {
            this.setState({ selectedTehsil, selectedVillage: null, allVillagesData: [] }, () => {
                this.updateNextButton();
            });
            this.getAllVillageById(selectedTehsil);
        }
    };

    handlePrerakChange = selectedPrerak => {

        this.setState({ selectedPrerak }, () => {
            this.updateNextButton();
        });
    };

    handleVillageChange = selectedVillage => {
        this.setState({ selectedVillage }, () => {
            this.updateNextButton();
        });
    };

    handleAppChange = selectedApps => {
        this.setState({ selectedApps }, () => {
            this.updateNextButton();
        });
    };

    onFocus = () => {
        this.setState({
            type: 'date'
        });
    }

    onBlur = () => {
        let fields = this.state.fields;
        fields["dob"] = moment(this._getFieldValue("dob", ""), "YYYY-MM-DD").format("DD-MM-YYYY");
        this.setState({
            type: 'text',
            fields
        });
        this.updateNextButton()
    }

    onSelectInputChange = () => {
        this.updateNextButton()
    }

    onSelectFocus = () => {
        this.updateNextButton()
    }

    onSelectBlur = () => {
        this.updateNextButton();
    }

    handleTabClick = (e, tab) => {
        e.preventDefault();
        Utilities.LogPrint("handleTabClick", tab);
        this.setState({
            currentTab: tab
        })
    }

    onIsPrerakChange = () => {
        const isPrerakChecked = document.getElementById("is_prerak").checked;
        Utilities.LogPrint("is_prerak", isPrerakChecked);
        this.setState({ isPrerakChecked, isPrerakVisible: !isPrerakChecked, canBePrerak: isPrerakChecked }, () => {
            this.updateNextButton();
        });
        this.props._handleIsPrerak(isPrerakChecked);
    }

    handleOnChange = (event) => {
        let value = event.target.value;
        let name = event.target.name;
        switch (name) {
            case "allIrrigationData": {
                this.setState({
                    selectedIrrigation: value
                }, () => {
                    this.updateNextButton();
                });
                break;
            }
            case "educational": {
                this.setState({
                    selectedEducation: value,
                }, () => {
                    this.updateNextButton();
                });
                break;
            }
            default:
                break;
        }

        switch (value) {
            case "PhoneUserYes": {
                this.setState({
                    isAppsVisible: true
                }, () => {
                    this.updateNextButton();
                })
                break;
            }
            case "PhoneUserNo": {
                this.setState({
                    isAppsVisible: false
                }, () => {
                    this.updateNextButton();
                })
                break;
            }
            case "PrerakYes": {
                this.setState({
                    isPrerakVisible: true
                }, () => {
                    this.updateNextButton();
                });
                break;
            }
            case "PrerakNo": {
                this.setState({
                    isPrerakVisible: false
                }, () => {
                    this.updateNextButton();
                });
                break;
            }
            case "CanPrerakYes": {
                this.setState({
                    canBePrerak: true
                }, () => {
                    this.updateNextButton();
                });
                this.props._handleIsPrerak(true);
                break;
            }
            case "CanPrerakNo": {
                this.setState({
                    canBePrerak: false
                }, () => {
                    this.updateNextButton();
                });
                this.props._handleIsPrerak(false);
                break;
            }
            default:
                break;
        }
        Utilities.LogPrint("handleOnChange", value);
    }


    render() {

        const { isVisible } = this.props;

        const name = this._getFieldValue("name", "");
        const dob = this._getFieldValue("dob", "");
        const mobile = this._getFieldValue("mobile", "");

        const { currentTab, isPrerakChecked, allQualificationData, allPrerakData, selectedEducation, selectedPrerak, selectedIrrigation, isAppsVisible, canBePrerak, isPrerakVisible, allAppsData, allIrrigationData, allStatesData, allDistrictsData, allTehsilsData, allVillagesData, selectedState, selectedDistrict, selectedTehsil, selectedVillage, selectedApps } = this.state;

        const allIrrigationListItem = allIrrigationData.map((irrigation, i) =>
            (irrigation.is_active ? (selectedIrrigation ? (selectedIrrigation === irrigation.name) ? <div key={i} className="radiobox-container w-50"><input type="radio" checked name="allIrrigationData" value={irrigation.name} /><span className="checkmark">{irrigation.name}</span></div> : <div key={i} className="radiobox-container w-50"><input type="radio" name="allIrrigationData" value={irrigation.name} /><span className="checkmark">{irrigation.name}</span></div> : <div key={i} className="radiobox-container w-50"><input type="radio" name="allIrrigationData" value={irrigation.name} /><span className="checkmark">{irrigation.name}</span></div>) : null)
        );

        const allQualificationListItem = allQualificationData.map((qualification, i) =>
        (qualification.is_active ?
            (selectedEducation ?
                selectedEducation === qualification.value ?
                    <div key={i} className="radiobox-container"><input type="radio" checked name="educational" value={qualification.value} /><span className="checkmark">{qualification.label}</span></div>
                    : <div key={i} className="radiobox-container"><input type="radio" name="educational" value={qualification.value} /><span className="checkmark">{qualification.label}</span></div>
                : <div key={i} className="radiobox-container"><input type="radio" name="educational" value={qualification.value} /><span className="checkmark">{qualification.label}</span></div>)
            : null)
        );

        return (
            <div className={isVisible ? "row krishak-tab-body space-top-none general-body" : "row krishak-tab-body general-body d-none"}>
                <div className="col-lg-4">
                    <ul className="general-info-menu">
                        <li className={currentTab === 0 ? "active" : ""} onClick={(e) => this.handleTabClick(e, 0)} data-tab="personalDetails">{ADD_KRISHAK_SCREEN.PERSONAL_DETAILS} <i className="customic ic-go-button ml-auto"></i></li>
                        <li className={currentTab === 1 ? "active" : ""} onClick={(e) => this.handleTabClick(e, 1)} data-tab="locationDetails">{ADD_KRISHAK_SCREEN.LOCATION_DETAILS} <i className="customic ic-go-button ml-auto"></i></li>
                        <li className={currentTab === 2 ? "active" : ""} onClick={(e) => this.handleTabClick(e, 2)} data-tab="additionalDetails">{ADD_KRISHAK_SCREEN.ADDITIONAL_DETAILS} <i className="customic ic-go-button ml-auto"></i></li>
                        <li className={currentTab === 3 ? "active" : ""} onClick={(e) => this.handleTabClick(e, 3)} data-tab="irrigationSource">{ADD_KRISHAK_SCREEN.IRRIGATION_SOURCE} <i className="customic ic-go-button ml-auto"></i></li>
                    </ul>
                </div>

                <div className="col-lg-8 general-info-form">
                    <form action="">
                        <div className="accordion" id="generalInfoForm">
                            {/* Personal Details */}
                            <div id="personalDetailsHeading" className="d-md-none accordion-heading">
                                <a href="" data-toggle="collapse" data-target="#personalDetails" aria-expanded="true" aria-controls="personalDetails">
                                    {ADD_KRISHAK_SCREEN.PERSONAL_DETAILS}
                                    {/* <i className={(name.length !== 0 && dob.length !== 0 && dob !== "Invalid date") ? "customic ic-check-mark ml-auto" : "customic ic-error ml-auto"}></i> */}
                                    <i className={(name.length !== 0) ? "customic ic-check-mark ml-auto" : "customic ic-error ml-auto"}></i>
                                    {/* <i className="customic ml-auto"></i> */}
                                    <i className="customic ic-go-button ml-3"></i>
                                </a>
                            </div>

                            <div id="personalDetails" className={currentTab === 0 ? "collapse accordion-body show" : "collapse accordion-body"} aria-labelledby="personalDetailsHeading" data-parent="#generalInfoForm">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter Name *" onChange={this._handleValueChange.bind(this, "name")} value={name} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            {/* <input type="text" className="form-control" value="+91 - 98765 43210" placeholder="" disabled /> */}
                                            <input type="number" className="form-control" disabled placeholder={HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER} onChange={this._handleValueChange.bind(this, "mobile")} value={mobile} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group input-date">
                                            <input type={this.state.type} min={moment().subtract(74, 'years').format("YYYY-MM-DD")} max={moment().subtract(1, 'days').format("YYYY-MM-DD")} id="dob" className="form-control mb-0" onFocus={this.onFocus} onBlur={this.onBlur} onChange={this._handleValueChange.bind(this, "dob")} placeholder={COMMON.DOB} value={dob} />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Location Details */}
                            <div id="locationDetailsHeading" className="d-md-none accordion-heading">
                                <a href="" className="collapsed" data-toggle="collapse" data-target="#locationDetails" aria-expanded="false" aria-controls="locationDetails">
                                    {ADD_KRISHAK_SCREEN.LOCATION_DETAILS}
                                    <i className={(selectedState && selectedTehsil && selectedDistrict && selectedVillage) ? "customic ic-check-mark ml-auto" : "customic ic-error ml-auto"}></i>
                                    {/* <i className="customic ml-auto"></i> */}
                                    <i className="customic ic-go-button ml-3"></i>
                                </a>
                            </div>
                            <div id="locationDetails" className={currentTab === 1 ? "collapse accordion-body show" : "collapse accordion-body"} aria-labelledby="locationDetailsHeading" data-parent="#generalInfoForm">
                                <div className="row">
                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedState}
                                            onChange={this.handleStateChange}
                                            options={allStatesData}
                                            placeholder={`${ADD_KRISHAK_SCREEN.SELECT_STATE} *`}
                                            isClearable={true}
                                            onInputChange={this.onSelectInputChange}
                                            onFocus={this.onSelectFocus}
                                            onBlur={this.onSelectBlur}
                                            onMenuClose={this.handleOnMenuClose}
                                        />
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedDistrict}
                                            onChange={this.handleDistrictChange}
                                            options={allDistrictsData}
                                            placeholder={`${ADD_KRISHAK_SCREEN.SELECT_DISTRICT} *`}
                                            isClearable={true}
                                            onFocus={this.onSelectFocus}
                                            onBlur={this.onSelectBlur}
                                            onMenuClose={this.handleOnMenuClose}
                                            isDisabled={selectedState === null ? true : false}
                                        />
                                    </div>

                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedTehsil}
                                            onChange={this.handleTehsilChange}
                                            options={allTehsilsData}
                                            placeholder={`${ADD_KRISHAK_SCREEN.SELECT_TEHSIL} *`}
                                            isClearable={true}
                                            onFocus={this.onSelectFocus}
                                            onBlur={this.onSelectBlur}
                                            onMenuClose={this.handleOnMenuClose}
                                            isDisabled={selectedDistrict === null ? true : false}
                                        />
                                    </div>

                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedVillage}
                                            onChange={this.handleVillageChange}
                                            options={allVillagesData}
                                            placeholder={`${ADD_KRISHAK_SCREEN.SELECT_VILLAGE} *`}
                                            isClearable={true}
                                            onFocus={this.onSelectFocus}
                                            onBlur={this.onSelectBlur}
                                            onMenuClose={this.handleOnMenuClose}
                                            isDisabled={selectedTehsil === null ? true : false}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Additional Details (Optional) */}
                            <div id="additionalDetailsHeading" className="d-md-none accordion-heading">
                                <a href="" className="collapsed" data-toggle="collapse" data-target="#additionalDetails" aria-expanded="false" aria-controls="additionalDetails">
                                    {ADD_KRISHAK_SCREEN.ADDITIONAL_DETAILS}
                                    <i className={
                                        ((isPrerakVisible != null ? (isPrerakVisible ? (selectedPrerak) : true) : false)
                                            && canBePrerak !== null) ? "customic ic-check-mark ml-auto" : "customic ic-error ml-auto"}></i>
                                    <i className="customic ic-go-button ml-3"></i>

                                    {/* <i className={((isAppsVisible != null ? (isAppsVisible ? (selectedApps.length !== 0) : true) : false)
                                        && selectedEducation !== null
                                        && (isPrerakVisible != null ? (isPrerakVisible ? (selectedPrerak) : true) : false)
                                        && canBePrerak !== null) ? "customic ic-check-mark ml-auto" : "customic ic-error ml-auto"}></i>
                                    <i className="customic ic-go-button ml-3"></i> */}
                                </a>
                            </div>

                            <div id="additionalDetails" className={currentTab === 2 ? "collapse accordion-body show" : "collapse accordion-body"} aria-labelledby="additionalDetailsHeading" data-parent="#generalInfoForm">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mb-0">
                                            <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.EDUCATIONAL_QUALIFICATION}</label>
                                            <div className="d-flex flex-wrap radiobox-container-row" onChange={this.handleOnChange}>
                                                {allQualificationListItem}
                                            </div>
                                        </div>

                                        <div className="form-group mb-0">
                                            <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.SMART_PHONE_USER}</label>
                                            <div className="d-flex flex-wrap radiobox-container-row" onChange={this.handleOnChange}>
                                                <div className="radiobox-container">{isAppsVisible !== null ? <input type="radio" checked={isAppsVisible} name="smartphone" value={"PhoneUserYes"} /> : <input type="radio" name="smartphone" value={"PhoneUserYes"} />}<span className="checkmark">{COMMON.YES}</span></div>
                                                <div className="radiobox-container">{isAppsVisible !== null ? <input type="radio" checked={!isAppsVisible} name="smartphone" value={"PhoneUserNo"} /> : <input type="radio" name="smartphone" value={"PhoneUserNo"} />}<span className="checkmark">{COMMON.NO}</span></div>
                                            </div>
                                        </div>
                                        <div className={isAppsVisible ? "form-group" : "d-none"}>
                                            <Select className=" max-w-360"
                                                isMulti
                                                value={selectedApps}
                                                onChange={this.handleAppChange}
                                                options={allAppsData}
                                                placeholder={ADD_KRISHAK_SCREEN.SELECT_APP_USED}
                                                isClearable={true}
                                                onFocus={this.onSelectFocus}
                                                onBlur={this.onSelectBlur}
                                                onMenuClose={this.handleOnMenuClose}
                                            />
                                        </div>

                                        <div className="form-group mb-10">
                                            <label className="cutom-checkbox-container">
                                                Is Prerak ?
                                                <input id="is_prerak" type="checkbox" onChange={this.onIsPrerakChange} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>

                                        <div className={isPrerakChecked ? "d-none" : "form-group mb-0"}>
                                            <label className="font-weight-medium">{COMMON.CAN_BE_PRERAK} *</label>
                                            <div className="d-flex flex-wrap radiobox-container-row" onChange={this.handleOnChange}>
                                                <div className="radiobox-container">{canBePrerak !== null ? <input type="radio" checked={canBePrerak} name="canprerak" value={"CanPrerakYes"} /> : <input type="radio" name="canprerak" value={"CanPrerakYes"} />}<span className="checkmark">{COMMON.YES}</span></div>
                                                <div className="radiobox-container">{canBePrerak !== null ? <input type="radio" checked={!canBePrerak} name="canprerak" value={"CanPrerakNo"} /> : <input type="radio" name="canprerak" value={"CanPrerakNo"} />}<span className="checkmark">{COMMON.NO}</span></div>
                                            </div>
                                        </div>
                                        <div className={isPrerakChecked ? "d-none" : "form-group mb-0"}>
                                            <label className="font-weight-medium">{COMMON.KNOW_YOUR_PRERAK}</label>
                                            <div className="d-flex flex-wrap radiobox-container-row" onChange={this.handleOnChange}>
                                                <div className="radiobox-container">{isPrerakVisible !== null ? <input type="radio" checked={isPrerakVisible} name="prerak" value={"PrerakYes"} /> : <input type="radio" name="prerak" value={"PrerakYes"} />}<span className="checkmark">{COMMON.YES}</span></div>
                                                <div className="radiobox-container">{isPrerakVisible !== null ? <input type="radio" checked={!isPrerakVisible} name="prerak" value={"PrerakNo"} /> : <input type="radio" name="prerak" value={"PrerakNo"} />}<span className="checkmark">{COMMON.NO}</span></div>

                                                <div className={isPrerakVisible ? "w-100 max-w-360 ml-2 mr-2 mb-3" : "d-none"}>
                                                    <Select className=" max-w-360"
                                                        value={selectedPrerak}
                                                        onChange={this.handlePrerakChange}
                                                        options={allPrerakData}
                                                        placeholder={COMMON.PRERAK}
                                                        isClearable={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Irrigation Source */}
                            <div id="irrigationSourceHeading" className="d-md-none accordion-heading">
                                <a href="" className="collapsed" data-toggle="collapse" data-target="#irrigationSource" aria-expanded="false" aria-controls="irrigationSource">
                                    {ADD_KRISHAK_SCREEN.IRRIGATION_SOURCE}
                                    {/* <i className={(selectedIrrigation) ? "customic ic-check-mark ml-auto" : "customic ic-error ml-auto"}></i> */}
                                    <i className="customic ic-check-mark ml-auto"></i>
                                    <i className="customic ic-go-button ml-3"></i>
                                </a>
                            </div>
                            <div id="irrigationSource" className={currentTab === 3 ? "collapse accordion-body show" : "collapse accordion-body"} aria-labelledby="irrigationSourceHeading" data-parent="#generalInfoForm">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mb-0">
                                            <div className="d-flex flex-wrap radiobox-container-row irrgation-item" onChange={this.handleOnChange}>
                                                {allIrrigationListItem}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default General
